<script setup lang='ts'>
  import useSlide from '@/composables/useSlide'
  import IbexaContentTypeIdentifier from '@/enums/IbexaContentTypeIdentifier'
  import type { Slide as SlideType } from '@/types/presentation/Slide'

  import SlideCoverImage from './SlideCoverImage.vue'
  import SlideSideBySide from './SlideSideBySide.vue'
  import SlideTextOnly from './SlideTextOnly.vue'
  import SlideVideo from './SlideVideo.vue'

  const props = defineProps<{
    contentId: number
  }>()

  const { slide } = useSlide(props.contentId)

  const slideComponentMap = (slide: SlideType) => {
    switch (slide.contentTypeIdentifier) {
    case IbexaContentTypeIdentifier.vgsSlideCoverImage:
      return SlideCoverImage
    case IbexaContentTypeIdentifier.vgsSlideSideBySide:
      return SlideSideBySide
    case IbexaContentTypeIdentifier.vgsSlideTextOnly:
      return SlideTextOnly
    case IbexaContentTypeIdentifier.vgsSlideVideo:
      return SlideVideo
    default:
      return undefined
    }
  }
</script>

<template>
  <component
    :is="slideComponentMap(slide)"
    v-if="slide"
    :slide="slide"
  />
</template>
